/**
 * Personalwesen (WALLIYO-0131), auf Deutsch. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrDe = {
  "hr.tabs.aria": "Personalwesen",
  "hr.tab.directory": "Verzeichnis",
  "hr.tab.recruiting": "Einstellung",
  "hr.tab.employees": "Mitarbeitende",
  "hr.tab.learning": "Weiterbildung",
  "hr.subTabs.aria": "Mitarbeitende",
  "hr.sub.records": "Akten",
  "hr.sub.joining": "Eintritt",
  "hr.sub.timeOff": "Abwesenheiten aller",
  "hr.sub.performance": "Leistung",
  "hr.sub.payroll": "Gehalt",
  "hr.sub.reviews": "Überprüfungen",
  "hr.sub.leaving": "Austritt",
  "hr.locked": "Dieser Reiter ist dem Personalwesen vorbehalten.",
  "hr.notBuilt": "Noch nicht gebaut.",
  "hr.notBuiltHelp": "Dieser Reiter ist entworfen und wartet auf seinen Endpunkt. Es geht nichts verloren.",
  "directory.title": "Verzeichnis",
  "directory.sub": "Jeder kann jeden nachschlagen.",
  "directory.search": "Jemanden finden",
  "directory.searchHelp": "Ein Name oder die Nummer auf dem Ausweis.",
  "directory.searchPlaceholder": "Name oder UUID",
  "directory.go": "Suchen",
  "directory.clear": "Alle anzeigen",
  "directory.loading": "Verzeichnis wird gelesen…",
  "directory.failed": "Das Verzeichnis konnte nicht gelesen werden.",
  "directory.retry": "Erneut versuchen",
  "directory.none": "Niemand hier passt zu „{query}“.",
  "directory.empty": "Noch ist niemand aufgeführt.",
  "directory.count": "{shown} von {total}",
  "directory.more": "Mehr Treffer als angezeigt. Suche eingrenzen.",
  "directory.colName": "Name",
  "directory.colRoles": "Rolle",
  "directory.colTeams": "Teams",
  "directory.colManager": "Führungskraft",
  "directory.open": "Öffnen",
  "directory.noRole": "Noch keine Rolle",
  "directory.noTeam": "Noch kein Team",
  "directory.noManager": "Keine Führungskraft",
  "directory.leads": "leitet es",
  "directory.invited": "Eingeladen",
  "directory.back": "Zurück zum Verzeichnis",
  "directory.identity": "Wer sie sind",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "Die Nummer auf dem Ausweis. Sie ändert sich nie.",
  "directory.email": "E-Mail",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Alle in ihren Teams",
  "directory.whereTheySit": "Wo sie sitzen",
  "directory.emailThem": "Eine E-Mail senden",
  "directory.teammatesNone": "Sie sind allein in ihren Teams.",
  "directory.personFailed": "Diese Person konnte nicht gelesen werden.",
  "directory.viewOnly": "Das Verzeichnis zeigt nur die Struktur. Was jemand darf, steht unter Mitarbeitende.",
  "hr.loading": "Wird gelesen…",
  "hr.failed": "Das konnte nicht gelesen werden.",
  "hr.retry": "Erneut versuchen",
  "joining.invite": "Jemanden einladen",
  "joining.invited.title": "Offene Einladungen",
  "joining.invited.help": "Sie haben bereits eine UUID und können sich erst mit einem Passwort anmelden.",
  "joining.invited.none": "Niemand wartet auf den Eintritt.",
  "joining.arrived.title": "Kürzlich eingetreten",
  "joining.arrived.help": "Alle, die in den letzten 30 Tagen dazugekommen sind.",
  "joining.arrived.none": "In den letzten 30 Tagen ist niemand dazugekommen.",
  "joining.col.name": "Name",
  "joining.col.roles": "Rolle",
  "joining.col.sent": "Eingeladen am",
  "joining.col.waiting": "Wartet seit",
  "joining.col.joined": "Eingetreten am",
  "joining.today": "Heute",
  "joining.waiting": "{days} Tage",
  "joining.stale": "Nachhaken lohnt sich",

  // ── Leaving ──
  "leaving.who": "Wer geht",
  "leaving.whoHelp": "Alle, die noch hier sind, und alle, die schon gegangen sind.",
  "leaving.pick": "Jemanden wählen",
  "leaving.alreadyLeft": "schon weg",
  "leaving.nobody": "Wählen Sie jemanden, um zu sehen, was ein Austritt hinterlassen würde.",
  "leaving.gone": "{name} ist bereits gegangen. Das sind die losen Enden.",
  "leaving.noReason": "Kein Grund angegeben",
  "leaving.teams.title": "Teams, die sie leiten",
  "leaving.teams.help":
    "In einem Team ohne Leitung genehmigt niemand Urlaub, überprüft niemanden und bestätigt niemandes Zugang — das ist dieselbe Sache.",
  "leaving.teams.none": "Sie leiten kein Team.",
  "leaving.teams.col.team": "Team",
  "leaving.teams.col.others": "Andere darin",
  "leaving.teams.col.after": "Nach dem Austritt",
  "leaving.team.others": "{count} andere",
  "leaving.team.noLead": "Niemand würde es leiten",
  "leaving.team.covered": "Jemand anders leitet es",
  "leaving.team.handOver": "Übergeben",
  "leaving.grants.title": "Namentlich gewährt",
  "leaving.grants.help":
    "Eine Rolle zu entziehen rührt daran nie. Eine Gewährung ohne Enddatum ist der Grund, warum jemand nach dem Austritt noch eine Berechtigung hat.",
  "leaving.grants.none": "Ihnen wurde nichts namentlich gewährt.",
  "leaving.grants.col.what": "Was",
  "leaving.grants.col.why": "Warum",
  "leaving.grants.col.ends": "Endet",
  "leaving.grant.forever": "Endet nie",
  "leaving.grant.until": "Bis",
  "leaving.grants.revoke": "Diese entziehen",
  "leaving.last.title": "Der letzte Schritt",
  "leaving.last.help":
    "Die Deaktivierung beendet ihre {sessions} offenen Sitzungen und verhindert die Anmeldung. Nichts von dem, was sie getan haben, wird entfernt — das Protokoll nennt sie für immer — und sie bleiben in ihren Teams gelistet, damit niemand heimlich eine Person zu wenig hat.",
  "leaving.last.deactivate": "Deaktivieren",
  "leaving.last.seeThem": "Im Verzeichnis ansehen",

  // ── Records ──
  "records.find": "Finden",
  "records.findPlaceholder": "Name oder E-Mail",
  "records.team": "Team",
  "records.role": "Rolle",
  "records.any": "Alle",
  "records.dueReview": "{count} Zugänge zu prüfen",
  "records.accessDueReview": "Zugang zu prüfen",
  "records.none": "Niemand passt dazu.",
  "records.neverSeen": "Nie angemeldet",
  "records.col.person": "Person",
  "records.col.role": "Rolle",
  "records.col.teams": "Teams",
  "records.col.joined": "Eingetreten",
  "records.col.lastSeen": "Zuletzt gesehen",

  // ── Time off ──
  "timeOff.ask": "Urlaub beantragen",
  "timeOff.approve": "Genehmigen",
  "timeOff.refuse": "Ablehnen",
  "timeOff.days": "{days} Tage",
  "timeOff.decidedBy": "Entschieden von {name}",
  "timeOff.col.who": "Wer",
  "timeOff.col.kind": "Art",
  "timeOff.col.when": "Wann",
  "timeOff.col.days": "Tage",
  "timeOff.col.status": "Status",
  "timeOff.kind.annual": "Jahresurlaub",
  "timeOff.kind.sick": "Krankheit",
  "timeOff.kind.unpaid": "Unbezahlt",
  "timeOff.kind.parental": "Elternzeit",
  "timeOff.kind.other": "Sonstiges",
  "timeOff.status.pending": "Wartet",
  "timeOff.status.approved": "Genehmigt",
  "timeOff.status.refused": "Abgelehnt",
  "timeOff.status.withdrawn": "Zurückgezogen",
  "timeOff.balance.title": "Ihr Stand",
  "timeOff.balance.none":
    "Ihr Anspruch wurde noch nicht festgelegt. Das Personalwesen tut das auf Ihren Beschäftigungsdaten.",
  "timeOff.balance.allowance": "Anspruch",
  "timeOff.balance.taken": "Genommen",
  "timeOff.balance.pending": "Beantragt",
  "timeOff.balance.pendingHelp": "Nicht genommen, aber auch nicht frei.",
  "timeOff.balance.left": "Übrig",
  "timeOff.toDecide.title": "Wartet auf Sie",
  "timeOff.toDecide.help":
    "Sie leiten ihr Team, also entscheiden Sie das. Im Personalwesen zu sein ist nicht dasselbe.",
  "timeOff.mine.title": "Ihre Anträge",
  "timeOff.mine.none": "Sie haben keinen Urlaub beantragt.",
  "timeOff.away.title": "Heute abwesend",
  "timeOff.away.none": "Heute ist niemand abwesend.",
  "timeOff.everybody.title": "Alle",
  "timeOff.everybody.help": "Sie sehen das, weil Sie im Personalwesen sind. Entschieden wird es von der Teamleitung.",
  "timeOff.form.title": "Urlaub beantragen",
  "timeOff.form.kind": "Art",
  "timeOff.form.from": "Erster Tag",
  "timeOff.form.to": "Letzter Tag",
  "timeOff.form.days": "Tage",
  "timeOff.form.daysHelp": "Wie viele Arbeitstage das umfasst.",
  "timeOff.form.reason": "Grund",
  "timeOff.form.submit": "Antrag senden",
  "timeOff.decide.title": "Diesen Antrag entscheiden",
  "timeOff.decide.approveNote": "Sagen Sie, warum Sie genehmigen",
  "timeOff.decide.refuseNote": "Sagen Sie, warum Sie ablehnen",
  "timeOff.decide.submit": "Entscheidung festhalten",
  "timeOff.done": "{days} Tage beantragt. Ihre Teamleitung entscheidet darüber.",
  "timeOff.approvedDone": "Der Urlaub von {name} ist genehmigt.",
  "timeOff.refusedDone": "Der Antrag von {name} ist abgelehnt.",

  // ── Reviews ──
  "reviews.grants.title": "Jetzt einen Blick wert",
  "reviews.grants.help":
    "Eine Gewährung mit Enddatum nimmt sich selbst zurück. Das sind die, die es nicht tun, und die von Leuten, die nicht mehr hier sind.",
  "reviews.grants.none": "Nichts ist namentlich ohne Enddatum gewährt.",
  "reviews.leads.title": "Führungskräfte, die hinsehen sollten",
  "reviews.leads.help": "Wer ihr Team leitet, wissen wir bereits — niemand muss erfahren, wer wen überprüft.",
  "reviews.leads.none": "Niemandes Leute halten etwas namentlich Gewährtes.",
  "reviews.col.who": "Wer",
  "reviews.col.what": "Was",
  "reviews.col.why": "Warum",
  "reviews.col.concern": "Bedenken",
  "reviews.col.lead": "Führungskraft",
  "reviews.col.team": "Team",
  "reviews.col.people": "Personen",
  "reviews.col.neverEnding": "Ohne Ende",
  "reviews.concern.holderLeft": "Hat das Haus verlassen",
  "reviews.concern.neverEnds": "Endet nie",
  "reviews.concern.neverUsed": "Nie genutzt",
  "reviews.changedAt": "Zuletzt geändert am {when}",
  "reviews.open": "Berechtigungen öffnen",

  // ── Payroll ──
  "payroll.month": "Monat",
  "payroll.open": "Einen Monat öffnen",
  "payroll.close": "Monat schließen",
  "payroll.notOpen": "Dieser Monat wurde noch nicht geöffnet.",
  "payroll.closedOn": "Am {when} von {name} geschlossen",
  "payroll.hold": "Sperren",
  "payroll.release": "Freigeben",
  "payroll.lines.title": "Was jede Person erhält",
  "payroll.lines.help":
    "Aus den Beschäftigungsdaten erstellt, wie sie beim Öffnen des Monats waren. Eine spätere Erhöhung ändert hier nichts.",
  "payroll.col.person": "Person",
  "payroll.col.gross": "Brutto",
  "payroll.col.contributions": "Beiträge",
  "payroll.col.net": "Netto",
  "payroll.col.status": "Status",
  "payroll.status.ready": "Bereit",
  "payroll.status.held": "Gesperrt",
  "payroll.status.paid": "Bezahlt",
  "payroll.total.people": "Personen",
  "payroll.total.gross": "Brutto",
  "payroll.total.contributions": "Beiträge",
  "payroll.total.net": "Netto",
  "payroll.missing.title": "Von diesen Personen weiß niemand, was sie verdienen",
  "payroll.missing.help":
    "Ihre Beschäftigungsdaten nennen kein Brutto, also kann eine Abrechnung sie nicht bezahlen. Vor dem nächsten Monat eintragen.",
  "payroll.openForm.title": "Einen Monat öffnen",
  "payroll.openForm.month": "Monat",
  "payroll.openForm.help":
    "Jede Beschäftigung mit einem Brutto bekommt eine Zeile. Beiträge beginnen bei null: was einbehalten wird, hängt davon ab, wo jemand ist, und das hat dieser Bildschirm nicht zu raten.",
  "payroll.openForm.submit": "Öffnen",
  "payroll.holdForm.title": "Diese Zeile ändern",
  "payroll.holdForm.hold": "Zurückhalten",
  "payroll.holdForm.release": "Freigeben",
  "payroll.closeForm.title": "Monat schließen",
  "payroll.closeForm.help":
    "Jede bereite Zeile wird bezahlt. Eine gesperrte bleibt gesperrt, genau dafür war das Sperren da.",
  "payroll.closeForm.submit": "Schließen",
  "payroll.opened": "{month} ist geöffnet, mit {count} Zeilen.",
  "payroll.held": "Die Zeile von {name} ist gesperrt.",
  "payroll.released": "Die Zeile von {name} wird bezahlt.",
  "payroll.closed": "Der Monat ist geschlossen.",

  // ── Performance ──
  "performance.cycle": "Zyklus",
  "performance.openCycle": "Einen Zyklus öffnen",
  "performance.noCycle": "Es wurde noch kein Zyklus geöffnet.",
  "performance.runs": "Läuft vom {from} bis {to}",
  "performance.write": "Schreiben",
  "performance.keepWriting": "Weiterschreiben",
  "performance.col.who": "Wer",
  "performance.col.reviewer": "Beurteilende Person",
  "performance.col.status": "Status",
  "performance.col.outcome": "Wie es lief",
  "performance.status.notStarted": "Nicht begonnen",
  "performance.status.inProgress": "Wird geschrieben",
  "performance.status.submitted": "Eingereicht",
  "performance.status.signedOff": "Abgezeichnet",
  "performance.gap.noTeam": "In keinem Team",
  "performance.gap.noLead": "Team hat keine Leitung",
  "performance.gap.leadsOwn": "Leitet das eigene Team",
  "performance.toWrite.title": "Wartet auf Sie",
  "performance.toWrite.help": "Sie leiten ihr Team, also schreiben Sie diese.",
  "performance.mine.title": "Ihre Beurteilung",
  "performance.mine.none": "Sie haben in diesem Zyklus keine Beurteilung.",
  "performance.everybody.title": "Alle",
  "performance.everybody.help":
    "Sie sehen das, weil Sie im Personalwesen sind. Geschrieben wird sie von der beurteilenden Person.",
  "performance.everybody.gaps":
    "{count} davon haben niemanden, der sie schreibt. Das sagt etwas über die Organisation, nicht über diesen Zyklus.",
  "performance.form.title": "Einen Zyklus öffnen",
  "performance.form.name": "Name",
  "performance.form.opens": "Erster Tag",
  "performance.form.closes": "Letzter Tag",
  "performance.form.submit": "Öffnen",
  "performance.writeForm.title": "Die Beurteilung schreiben",
  "performance.writeForm.outcome": "Wie es lief",
  "performance.writeForm.outcomeHelp": "Ein Wort Ihrer Wahl, keine Note von fünf.",
  "performance.writeForm.note": "Was passiert ist",
  "performance.writeForm.save": "Für später speichern",
  "performance.writeForm.send": "Einreichen",
  "performance.opened": "{name} ist geöffnet, mit {count} Beurteilungen.",
  "performance.saved": "Gespeichert. Niemand sieht sie, bis Sie einreichen.",
  "performance.sent": "Eingereicht. {name} kann sie jetzt sehen.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Eine Stelle ausschreiben",
  "recruiting.editJob": "Ändern",
  "recruiting.addCandidate": "Jemanden hinzufügen",
  "recruiting.move": "Weiterbewegen",
  "recruiting.none": "Es wurde noch keine Stelle ausgeschrieben.",
  "recruiting.noTeam": "Kein Team",
  "recruiting.noCandidates": "Es hat sich noch niemand beworben.",
  "recruiting.liveCandidates": "{count} im Rennen",
  "recruiting.col.candidate": "Bewerbung",
  "recruiting.col.reach": "Wie man sie erreicht",
  "recruiting.col.stage": "Phase",
  "recruiting.col.applied": "Beworben",
  "recruiting.stage.applied": "Beworben",
  "recruiting.stage.screening": "Vorauswahl",
  "recruiting.stage.interview": "Gespräch",
  "recruiting.stage.offer": "Angebot raus",
  "recruiting.stage.hired": "Eingestellt",
  "recruiting.stage.declined": "Abgelehnt",
  "recruiting.stage.withdrawn": "Zurückgezogen",
  "recruiting.status.open": "Offen",
  "recruiting.status.onHold": "Pausiert",
  "recruiting.status.filled": "Besetzt",
  "recruiting.status.closed": "Geschlossen",
  "recruiting.jobForm.title": "Eine Stelle ausschreiben",
  "recruiting.jobForm.name": "Titel",
  "recruiting.jobForm.team": "Team",
  "recruiting.jobForm.noTeam": "Noch kein Team",
  "recruiting.jobForm.description": "Worum es geht",
  "recruiting.jobForm.status": "Status",
  "recruiting.jobForm.submit": "Ausschreiben",
  "recruiting.candidateForm.title": "Jemanden hinzufügen",
  "recruiting.candidateForm.name": "Name",
  "recruiting.candidateForm.phone": "Telefon",
  "recruiting.candidateForm.email": "E-Mail",
  "recruiting.candidateForm.note": "Was man wissen sollte",
  "recruiting.candidateForm.submit": "Hinzufügen",
  "recruiting.moveForm.title": "Weiterbewegen",
  "recruiting.moveForm.stage": "Phase",
  "recruiting.moveForm.hired":
    "Jemanden als eingestellt zu markieren hält fest, dass es geschah. Eingeladen wird über Eintritt, wo das schon existiert.",
  "recruiting.moveForm.submit": "Weiterbewegen",
  "recruiting.jobOpened": "{title} ist offen.",
  "recruiting.jobEdited": "{title} ist aktualisiert.",
  "recruiting.candidateAdded": "{name} steht auf der Liste.",
  "recruiting.candidateMoved": "{name} ist jetzt bei {stage}.",
  "learning.addCourse": "Einen Kurs anlegen",
  "learning.enrol": "Anmelden",
  "learning.continue": "Weitermachen",
  "learning.finish": "Abschließen",
  "learning.alreadyEnrolled": "Angemeldet",
  "learning.requiredBy": "Erforderlich für {permission} — vor der Gewährung abzuschließen, nicht danach.",
  "learning.requiredOfAll": "Für alle verpflichtend",
  "learning.anybody": "Für alle offen",
  "learning.minutes": "{minutes} Min",
  "learning.enrolled": "{count} angemeldet",
  "learning.hrOnly": "Nur Personalwesen",
  "learning.mine.title": "Für Sie verpflichtend",
  "learning.mine.help": "Ein Kurs an einer Berechtigung muss abgeschlossen sein, bevor die Berechtigung gewährt wird.",
  "learning.mine.none": "Im Moment ist für Sie nichts verpflichtend.",
  "learning.catalogue.title": "Katalog",
  "learning.catalogue.help":
    "Für alle offen. Für die Anmeldung braucht es niemandes Erlaubnis — die braucht die Gewährung hinter dem Kurs.",
  "learning.byTeam.title": "Im ganzen Unternehmen",
  "learning.byTeam.help": "Wer die Pflichtkurse noch schuldet. Nachhaken tut die Teamleitung.",
  "learning.col.course": "Kurs",
  "learning.col.status": "Status",
  "learning.col.progress": "Fortschritt",
  "learning.col.team": "Team",
  "learning.col.people": "Personen",
  "learning.col.done": "Fertig",
  "learning.status.enrolled": "Angemeldet",
  "learning.status.inProgress": "Läuft",
  "learning.status.done": "Abgeschlossen",
  "learning.courseForm.title": "Einen Kurs anlegen",
  "learning.courseForm.name": "Titel",
  "learning.courseForm.audience": "Für wen",
  "learning.courseForm.minutes": "Dauer, in Minuten",
  "learning.courseForm.required": "Für eine Berechtigung erforderlich",
  "learning.courseForm.requiredHelp": "Die Setting-ID der Berechtigung, für die dieser Kurs Bedingung ist.",
  "learning.courseForm.everybody": "Für alle verpflichtend",
  "learning.courseForm.submit": "Anlegen",
  "learning.courseAdded": "{title} ist im Katalog.",
  "learning.enrolledDone": "Für {title} angemeldet.",
  "learning.finished": "{title} ist abgeschlossen.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Schließen",
  "error.reason.permission_not_held":
    "Ihre Rolle öffnet diesen Bildschirm, aber nicht diese Aktion. Fragen Sie jemanden, der sie gewähren kann.",
  "error.reason.not_found": "Das gibt es nicht mehr. Neu laden und erneut versuchen.",
  "error.reason.no_reason": "Sagen Sie kurz, warum.",
  "error.reason.name_taken": "Dieser Name ist bereits vergeben.",
  "error.reason.team_closed": "Das ist geschlossen. Öffnen Sie es wieder, bevor Sie jemanden hinzufügen.",
  "error.reason.staff_deactivated": "Diese Person ist gegangen und kann nicht hinzugefügt werden.",
  "error.reason.lead_must_be_member": "Man leitet nur ein Team, in dem man ist.",
  "error.reason.duplicate_change": "Dieselbe Person kommt zweimal vor. Schicken Sie sie einmal.",
  "error.reason.own_request": "Sie können nicht über Ihren eigenen Urlaub entscheiden.",
  "error.reason.not_their_lead":
    "Nur wer ihr Team leitet, entscheidet das. Im Personalwesen zu sein ist nicht dasselbe.",
  "error.reason.already_decided": "Das ist bereits entschieden. Neu laden, um zu sehen, wie.",
  "error.reason.backwards": "Der letzte Tag liegt vor dem ersten.",
  "error.reason.too_long": "Das ist länger, als ein Antrag abdecken kann.",
  "error.reason.month_open": "Dieser Monat ist bereits geöffnet.",
  "error.reason.already_paid": "Diese Zeile wurde bezahlt. Ein geschlossener Monat ist, was bezahlt wurde.",
  "error.reason.already_closed": "Dieser Monat ist bereits geschlossen.",
  "error.reason.nobody_payable": "Auf keinen Beschäftigungsdaten ist ein Brutto eingetragen.",
  "error.reason.invalid_month": "Geben Sie den Monat als JJJJ-MM an.",
  "error.reason.own_review": "Sie können Ihre eigene Beurteilung nicht schreiben.",
  "error.reason.not_the_reviewer": "Jemand anderes wurde darum gebeten.",
  "error.reason.signed_off": "Diese Beurteilung ist abgezeichnet.",
  "error.reason.no_outcome": "Sagen Sie, wie es lief, bevor Sie einreichen.",
  "error.reason.job_closed": "Diese Stelle ist geschlossen. Öffnen Sie sie wieder, bevor Sie jemanden hinzufügen.",
  "error.reason.candidate_out":
    "Diese Person ist nicht mehr im Rennen. Fügen Sie sie erneut hinzu, wenn sie zurückkommt.",
  "error.reason.title_taken": "Dieser Titel ist bereits vergeben.",
  "error.reason.course_retired": "Dieser Kurs wird nicht mehr angeboten.",
  "error.reason.invalid_progress": "Fortschritt ist ein ganzes Prozent, von 0 bis 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Alles",
  "roles.covers.features": "{count} Funktionen",
  "roles.covers.permissions": "{count} Berechtigungen",
  "roles.covers.critical": "{count} kritisch",
  "roles.covers.high": "{count} hoch",
  "roles.covers.seeAll": "Alle {count} ansehen",
  "roles.covers.permissionsHeading": "Berechtigungen",

  // ── Roles, redesigned ──
  "roles.band.critical": "Rollen können entscheiden, was alle anderen dürfen",
  "roles.band.people": "Personen halten eine davon",
  "roles.band.total": "Rollen insgesamt",
  "roles.band.unheld": "hält niemand",
  "roles.reach.critical": "Kritisch",
  "roles.reach.high": "Hoch",
  "roles.reach.low": "Niedrig",
  "roles.rail.people": "{count} Personen",
  "roles.rail.unheld": "niemand hält sie",
  "roles.noDescription": "Keine Beschreibung",
  "roles.figure.people": "Personen",
  "roles.figure.features": "Funktionen",
  "roles.figure.permissions": "Berechtigungen",
  "roles.figure.critical": "Kritisch",
  "roles.block.holders": "Wer sie hält",
  "roles.block.holdersHelp": "Wer diese Rolle bekommt, bekommt alles Folgende.",
  "roles.block.holdersNone": "Niemand hält diese Rolle.",
  "roles.block.give": "Jemandem geben",
  "roles.block.take": "Entziehen",
  "roles.block.grants": "Was sie gewährt",
  "roles.block.grantsHelp": "Wie weit sie reicht, nach Bereich.",
  "roles.block.criticalWarning": "Wer diese Rolle hält, kann entscheiden, was alle anderen dürfen.",
  "roles.block.change": "Ändern, was sie gewährt",
  "roles.block.opens": "Was sie öffnet",
  "roles.block.opensHelp": "Aus den Funktionen oben berechnet, nie gespeichert — das Menü fragt dieselbe Funktion.",
  "roles.block.opensNone": "Sie öffnet allein keinen Bildschirm.",
  "roles.block.compare": "Verglichen mit",
  "roles.block.compareWith": "Vergleichen mit",
  "roles.compare.only": "{count} nur hier",
  "roles.compare.theirs": "{count} nur dort",
  "roles.compare.shared": "{count} gemeinsam",
  "roles.give.title": "Diese Rolle jemandem geben",
  "roles.give.who": "Wem",
  "roles.give.submit": "Geben",
  "roles.give.done": "{name} hält jetzt {role}.",
  "roles.take.title": "Diese Rolle entziehen",
  "roles.take.body": "Alle anderen Rollen bleiben.",
  "roles.take.submit": "Entziehen",
  "roles.take.done": "{name} hält {role} nicht mehr.",
  "roles.holdersUnknown": "Nicht lesbar",
  "roles.compare.same": "Sie gewähren genau dieselben Funktionen.",
  "roles.notice.critical": "{roles} davon können entscheiden, was alle anderen dürfen — {people} Personen halten eine.",
  "roles.notice.criticalOnly": "{roles} davon können entscheiden, was alle anderen dürfen.",
  "roles.notice.unheld": "{count} hält niemand.",

  // ── Actions, by person ──
  "actions.find": "Jemanden finden",
  "actions.matches": "Wen meinten Sie?",
  "actions.findPlaceholder": "Name oder UUID",
  "actions.nobody": "Suchen Sie jemanden, um zu sehen, was er darf.",
  "actions.noRoles": "Keine Rolle",
  "actions.col.on": "An",
  "actions.col.source": "Quelle",
  "actions.col.reason": "Grund",
  "actions.mustAsk": "muss über {limit} fragen",
  "actions.clear": "Löschen",
  "actions.until": "bis {when}",
  "actions.onlyOverrides":
    "Nur eine Ausnahme ist auf diese Person gesetzt, also die einzige, die dieser Bildschirm entfernen kann. Alles andere kommt aus einer Rolle oder daher, wie die Aktion ausgeliefert wird — ändern Sie das dort, wo es lebt.",
  "actions.blocked.permission": "Sie haben die Funktion, nicht die Berechtigung, die diese Aktion verlangt.",
  "actions.locked.noFeature": "Für alle offen: dahinter liegt kein Schalter.",
  "actions.view.catalogue": "Der Katalog",
  "actions.view.person": "Nach Person",
  "actions.notWiredYet":
    "Das Einschalten ist noch nicht angeschlossen. Nutzen Sie vorerst Funktionen und Berechtigungen.",
  "actions.view.role": "Nach Rolle",
  "actions.pickRole": "Rolle",

  // ── Switching an action ──
  "actions.switch.onTitle": "Einschalten",
  "actions.switch.offTitle": "Ausschalten",
  "actions.switch.clearTitle": "Löschen",
  "actions.switch.submit": "Einschalten",
  "actions.switch.writes": "Das schreibt die dahinterliegende Funktion: {feature}.",
  "actions.switch.alsoMoves": "Diese Funktion öffnet auch {count} weitere Aktionen, die mitgehen: {actions}.",
  "actions.switch.permissionToo":
    "Die Berechtigung, die diese Aktion verlangt, fehlt weiterhin. Gewähren Sie sie unter Berechtigungen.",
  "actions.switch.switchedOn": "{action} ist für {who} an.",
  "actions.switch.switchedOff": "{action} ist für {who} aus.",
  "actions.switch.cleared": "{action} fällt auf das Geerbte zurück.",
  "actions.pending": "noch nicht gespeichert",
  "actions.saved": "{count} Schalter gespeichert.",
} as const;
